import React, { useState, useRef, useEffect } from 'react';
import './CustomToggle.scss';

const CustomToggle = ({
  leftLabel,
  rightLabel,
  leftValue = null,
  rightValue = null,
  handleSetState,
  name,
  disabled = false,
}) => {
  const [selected, setSelected] = useState('left');
  const rootRef = useRef(null);
  
  const handleSelect = (value) => {
    if (disabled) return;
    const selectedValue = value === 'left' ? leftValue : rightValue;
    setSelected(value);
    handleSetState?.(selectedValue ?? leftValue);
  };

  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      handleSelect('left');
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      handleSelect('right');
    } else if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      handleSelect(selected === 'left' ? 'right' : 'left');
    }
  };

  return (
    <div
      ref={rootRef}
      className={`seg-toggle ${disabled ? 'seg-toggle--disabled' : ''}`}
      role="switch"
      tabIndex={disabled ? -1 : 0}
      aria-checked={selected === 'right'}
      aria-label={`${leftLabel} or ${rightLabel}`}
      aria-disabled={disabled}
      data-name={name}
      onKeyDown={handleKeyDown}
    >
      <span
        className={`seg-option ${selected === 'left' ? 'seg-option--active' : ''}`}
        onClick={(e) => { e.stopPropagation(); handleSelect('left'); }}
      >
        {leftLabel}
      </span>
      <span className="seg-divider" aria-hidden="true" />
      <span
        className={`seg-option ${selected === 'right' ? 'seg-option--active' : ''}`}
        onClick={(e) => { e.stopPropagation(); handleSelect('right'); }}
      >
        {rightLabel}
      </span>
    </div>
  );
};

export default CustomToggle;